import React from 'react';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Navigation from './Navigation';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';

interface LayoutProps {
    children: React.ReactNode;
    cartItemsCount?: number;
    cartTotal?: number;
}

const Layout: React.FC<LayoutProps> = ({
    children,
    cartItemsCount = 0,
    cartTotal = 0
}) => {
    return (
        <div className="flex flex-col min-h-screen">
            {/* Promo bar (all breakpoints) */}
            <AnnouncementBar />

            {/* Desktop Header and Navigation */}
            <Header cartItemsCount={cartItemsCount} cartTotal={cartTotal} />
            <Navigation />
            
            {/* Mobile Navigation */}
            <MobileNavigation cartItemsCount={cartItemsCount} cartTotal={cartTotal} />
            
            <main className="container mx-auto px-4 py-6 flex-grow">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;